// removed by extract-text-webpack-plugin
module.exports = {"container":"_3cEB6","elementSpacing":"_22h_P","blockStyleSpacing":"NUbo2","text":"FKgzh _22h_P","comment":"_1GRia","quote":"_3hNg5 NUbo2","headerOne":"_13jxB _22h_P","headerTwo":"EJvdv _22h_P","atomic":"uSErq","placeholderRight":"_1EuaY","placeholderCenter":"_1UYbE","placeholderHidden":"_1FyTs"};


//////////////////
// WEBPACK FOOTER
// ./app/components/styled-text-editor/text-editor-theme.scss
// module id = 819
// module chunks = 3 4 5 6 7